export const ADD = 'entities/volunteers/ADD';
export const ADD_MULTIPLE = 'entities/volunteers/ADD_MULTIPLE';
export const SET_TOTAL_VOLUNTEERS = 'entities/volunteers/SET_TOTAL_VOLUNTEERS';
export const SET_DISPLAYED_VOLUNTEER_IDS = 'entities/volunteers/SET_DISPLAYED_VOLUNTEER_IDS';
export const UPDATE_VOLUNTEER_STATUS = 'entities/volunteers/UPDATE_VOLUNTEER_STATUS';
export const UPDATE_VOLUNTEER_PROPERTY = 'entities/volunteers/UPDATE_VOLUNTEER_PROPERTY';
